export const CHECK_RESULT_RATING_MAIL_SUCCESS = 'CHECK_RESULT_RATING_MAIL_SUCCESS';

export const checkResultRatingMailSuccess = ( allowToSendMail ) => ({
    type: CHECK_RESULT_RATING_MAIL_SUCCESS,
    payload: { allowToSendMail },
});
